import React from "react";
import Medal from "./Medal";
import styles from "./styles/AllMedals.module.css";
import useTranslation from "next-translate/useTranslation";
import { getModeNameCapitalFirst, getModeIcon } from "../util/util";

import { ModeIds } from "@chesshotel/constants";

const modeIds = [
  ModeIds.BULLET,
  ModeIds.BLITZ,
  ModeIds.RAPID,
  ModeIds.CHESS960,
  ModeIds.DAILY,
];

export default function AllMedals({ medalData, size = "medium" }) {
  const { t } = useTranslation("common");

  function renderMedal(leagueName, rank, modeId) {
    const leagueNameStr = leagueName + " league";
    const tranlatedLeagueName = t(leagueNameStr).toUpperCase();

    return (
      <div className={styles.medal} key={leagueName + modeId}>
        <div className="flex flex-col items-center">
          <div className="flex items-center mb-1 space-x-1 font-semibold">
            {/* <div>{getModeIcon(modeId)}</div> */}
            <div>{getModeNameCapitalFirst(modeId, t)}</div>
          </div>
          {/* <div className={styles.leagueTitle}>{tranlatedLeagueName}</div> */}
        </div>
        <span className="has-tooltip">
          <span className="tooltip">
            {getModeNameCapitalFirst(modeId, t).toUpperCase() +
              " " +
              tranlatedLeagueName}
          </span>
          <Medal rank={rank} title="RANK" leagueName={leagueName} size={size} />
        </span>
      </div>
    );
  }

  function renderMedals() {
    return modeIds.map((modeId) => {
      if (medalData[modeId] && medalData[modeId].leagueName !== "placement") {
        const leagueName = medalData[modeId].leagueName;
        const rank = medalData[modeId].rank;

        return renderMedal(leagueName, rank, modeId);
      } else {
        return undefined;
      }
    });
  }

  return <>{renderMedals()}</>;
}
